
import NJ17Oct2026Riaan1 from "../Assets/NJ-17Oct2026-Riaan-1.jpeg";
import NJ17Oct2026Riaan2 from "../Assets/NJ-17Oct2026-Riaan-2.jpeg";
import NJ17Oct2026Riaan3 from "../Assets/NJ-17Oct2026-Riaan-3.jpeg";
import NJ27Sep2026Ishan1 from "../Assets/NJ-27Sep2026-Ishan-1.jpeg";
import NJ27Sep2026Ishan2 from "../Assets/NJ-27Sep2026-Ishan-2.jpeg";
import NJ27Sep2026Ishan3 from "../Assets/NJ-27Sep2026-Ishan-3.jpeg";
import NJ27Sep2026Ishan4 from "../Assets/NJ-27Sep2026-Ishan-4.jpeg";
import NJChapter1 from "../Assets/NJ-19Sep2026-Group-4.jpeg";
import NJChapter2 from "../Assets/NJ-19Sep2026-Group-3.jpeg";
import NJChapter3 from "../Assets/NJ-19Sep2026-Group-2.jpeg";
import NJChapter4 from "../Assets/NJ-19Sep2026-Group-1.jpeg";

const NewJerseyPhotos = [
  // October 17, 2026 session
  {
    img: NJ17Oct2026Riaan1,
    alt: "New Jersey - Riaan coaching session - Oct 17, 2026 - 1",
  },
  {
    img: NJ17Oct2026Riaan2,
    alt: "New Jersey - Riaan coaching session - Oct 17, 2026 - 2",
  },
  {
    img: NJ17Oct2026Riaan3,
    alt: "New Jersey - Riaan coaching session - Oct 17, 2026 - 3",
  },
  // September 27, 2026 session
  {
    img: NJ27Sep2026Ishan1,
    alt: "New Jersey - Ishan coaching session - Sep 27, 2026 - 1",
  },
  {
    img: NJ27Sep2026Ishan2,
    alt: "New Jersey - Ishan coaching session - Sep 27, 2026 - 2",
  },
  {
    img: NJ27Sep2026Ishan3,
    alt: "New Jersey - Ishan coaching session - Sep 27, 2026 - 3",
  },
  {
    img: NJ27Sep2026Ishan4,
    alt: "New Jersey - Ishan coaching session - Sep 27, 2026 - 4",
  },
  // September 19, 2026 session
  {
    img: NJChapter1,
    alt: "New Jersey - Training session at MatchPoint Table Tennis Center - 1",
  },
  {
    img: NJChapter2,
    alt: "New Jersey - Coaching session with youth players - 2",
  },
  {
    img: NJChapter3,
    alt: "New Jersey - Group instruction at MatchPoint - 3",
  },
  {
    img: NJChapter4,
    alt: "New Jersey - Youth table tennis clinic - 4",
  },
];

export default NewJerseyPhotos;
